/**
 * @generated SignedSource<<0c25f80bd0cebb6eb7dcb42728c888be>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePackageDisplayName_package$data = {
  readonly displayInApp: {
    readonly displayName: string;
  } | null | undefined;
  readonly name: string;
  readonly " $fragmentType": "usePackageDisplayName_package";
};
export type usePackageDisplayName_package$key = {
  readonly " $data"?: usePackageDisplayName_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePackageDisplayName_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "usePackageDisplayName_package",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DisplayInApp",
      "kind": "LinkedField",
      "name": "displayInApp",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Package",
  "abstractKey": "__isPackage"
};

(node as any).hash = "5d9e4e4a79dc43ae70fef9e0b4bd98ae";

export default node;
